// app/page.tsx
'use client';

import { Suspense } from 'react';
import SpreadControl from '@/customs/spreadcontrol';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import * as Global from '@/utils/global';
import * as AuthContext from '@/utils/authcontext';

// // CSR専用に指定（プリレンダリング回避）
// export const dynamic = "force-dynamic";
// // キャッシュ完全無効化
// export const revalidate = false;

export default function SpreadPage() {

  AuthContext.useAuthRedirect();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SpreadControl />
    </Suspense>
  );
}